import React, { useState } from 'react'
import cbt1 from '../assets/images/cbt1.png'
import cbt2 from '../assets/images/cbt2.png'
import cbt3 from '../assets/images/cbt3.png'
import cbt4 from '../assets/images/cbt4.png'
import cbt5 from '../assets/images/cbt5.png'
import { IoArrowBackOutline, IoArrowForward } from "react-icons/io5";
import { motion } from 'framer-motion'
import DashboardLayout from './DashboardLayout'



const CBT = () => {
  const [preview, setPreview] = useState(0)


  const gallery = [
    {
      id: 1,
      image : cbt1,
      alt : 'image_1'
    },
    {
      id: 2,
      image : cbt2,
      alt : 'image_2'
    },
    {
      id: 3,
      image : cbt3,
      alt : 'image_3'
    },
    {
      id: 4,
      image : cbt4,
      alt : 'image_4'
    },
    {
      id: 5,
      image : cbt5,
      alt : 'image_5'
    },
  ]


  const handleForward = () => {
    setPreview((preview + 1) % gallery.length);
  }

  const handleBackward = () => {
    setPreview((preview - 1 + gallery.length) % gallery.length);
  }

  const handleGallery = (item) => {
    setPreview(item -1)
  }


  return (
    <DashboardLayout cbt="Computer based test (CBT)"childTab={11} animated={true}>
    <div className='flex flex-col items-center justify-center w-full px-5 pb-7 md:px-6 lg:relative lg:px-7 xl:px-10 xl:pb-10'>
          <div className='flex-col items-center w-full mt-10 md:mt-12 xl:mt-14'>
              {/*PREVIEW IMAGE*/}
              <div className='relative flex flex-col items-center justify-center w-full'>
                  <motion.div
                   initial={{scale: 1, opacity: 0, }}
                   animate={{scale: 1, opacity: [0, 0.1, 0.3, 0.5, 1.0] }}
                   transition={{ duration: 0.5, delay: 0.15, easing: "easeOut", }}
                   key={gallery[preview].image}
                   className='w-full md:w-[65%] md:h-full xl:w-[68%]'>
                      <img className='w-full h-full object-cover rounded-md'
                      src={gallery[preview].image} 
                      alt='preview_image' loading='lazy' />
                  </motion.div>

                  {/*NAVIGATION*/}
                  <div className='flex items-center justify-center w-full mt-7 md:absolute md:justify-between md:mb-7 lg:w-[95%] xl:w-[94%]'>
                       <div onClick={handleBackward}
                       className='flex items-center justify-center border-[3px] h-8 w-8 rounded-full mx-10 text-[#25A249] border-[#25A249] hover:bg-[#25A249]
                                 hover:text-[#ffffff] xl:h-12 xl:w-12 xl:border-4'>
                           <IoArrowBackOutline className='text-xl xl:text-3xl' />
                       </div>
    
                       <div onClick={handleForward}
                       className='flex items-center justify-center border-[3px] h-8 w-8 rounded-full mx-10 text-[#25A249] border-[#25A249] hover:bg-[#25A249]
                                  hover:text-[#ffffff] xl:h-12 xl:w-12 xl:border-4'>
                           <IoArrowForward className='text-xl xl:text-3xl' />
                       </div>
                  </div>
              </div>

          </div>

          <div className='relative flex items-center justify-start w-full mt-12 md:w-[65%] md:mt-4 xl:w-[68%]'>
             <div className='hidden md:flex items-center justify-center absolute left-[-30px] border-2 h-[18px] w-[18px] mt-3 rounded-full text-[#25A249] border-[#25A249]
                             hover:bg-[#25A249] hover:text-[#ffffff] xl:h-6 xl:w-6 xl:left-[-35px] xl:border-[3px]'>
                 <IoArrowBackOutline className='text-sm xl:text-3xl' />
             </div>

             <div className='flex items-center justify-center flex-wrap w-full md:flex-nowrap'>
              {gallery.map((item) => {
               return(
               <div key={item.id} onClick={()=>handleGallery(item.id)}
               className='flex items-center justify-center w-[31%] mt-2 mr-1 md:w-[400px] md:mt-3 lg:mt-3.5 xl:w-[23%] xl:mt-4'>
                  <img className={`w-full h-full rounded-[4px] md:rounded-md xl:rounded-lg ${preview === item.id - 1 && 'border-2 border-[#F1C21B] md:border-[3px] xl:border-4'}`}
                  src={item.image} alt='img_1' loading='lazy' />
               </div>
                )
               })}
             </div>

             <div className='hidden md:flex items-center justify-center absolute right-[-27px] border-2 h-[18px] w-[18px] mt-3 rounded-full text-[#25A249] border-[#25A249]
                            hover:bg-[#25A249] hover:text-[#ffffff] xl:h-6 xl:w-6 xl:right-[-32px] xl:border-[3px]'>
                 <IoArrowForward className='text-sm xl:text-3xl' />
             </div>
          </div>
          
    </div>
    </DashboardLayout>
  )
}

export default CBT
